import React from 'react';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { overridable } from '@24i/nxg-sdk-gluons/src/context/ComponentOverrides';
const LiveBadge = () => {
    var _a;
    const { theme } = useTheme();
    return (React.createElement("div", { style: {
            backgroundColor: ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.progressBarLive) || '#00addd',
            width: 34,
            height: 20,
            marginLeft: 6,
            paddingLeft: 1,
            borderRadius: 4,
        } },
        React.createElement("span", { style: {
                color: '#ffffff',
                letterSpacing: -0.1,
                fontSize: 13,
                padding: 3,
                fontWeight: 'bold',
            } }, "LIVE")));
};
export default overridable(LiveBadge, 'LiveBadge');
//# sourceMappingURL=index.js.map